var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{key:_vm.name},[_c('TooltipTd',{attrs:{"variableName":_vm.name,"description":_vm.description,"deviceType":_vm.deviceType,"node":_vm.node}}),_c('td',{attrs:{"align":"right"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.setExternal()}}},[_c('v-icon',[_vm._v("mdi-eye")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }